
import { LogicRule } from "./types";

// Re-export the types
export type { LogicRule };

// Empty arrays for compatibility with existing code
export const objectiveRules: LogicRule[] = [];
export const subjectiveRules: LogicRule[] = [];
export const additionalRules: LogicRule[] = [];
export const miscRules: LogicRule[] = [];

// Combine all rules into one array (now empty as we use spreadsheet data)
export const allLogicRules: LogicRule[] = [];
